
const DEFAULT_COUNT_BOXES = 50;
const BETA_ENV = "beta";

const YES = "YES";
const NO = "NO";

const SHOPIFY = "SHOPIFY";
const AMAZON = "AMAZON";

const PURCHASE_ORDER_TYPE = "PurchaseOrder";
const VENDOR_SHIP_TODAY = "VENDOR_SHIP_TODAY";
const VENDOR_SHIP_SOON = "VENDOR_SHIP_SOON";
const VENDOR_SHIP_OLD = "VENDOR_SHIP_OLD";
const PO_EMAIL = "PO_EMAIL";
const PO_PAYMENT_CONFIRMATION = "PO_PAYMENT_CONFIRMATION";

const endDateOfProfitAndLossReport = 5;

const enumCommonBooleanStatuses = {
    [YES]: 'Yes',
    [NO]: 'No',
}

const enumShopifyAmazon = {
    [SHOPIFY]: 'Shopify',
    [AMAZON]: 'Amazon'
}; 

const SHOPIFY_AMAZON_FILTERS = [
    SHOPIFY,
    AMAZON
];

const BOOLEAN_FILTERS = [
    YES,
    NO
];

const monthNames = {
    "Jan": "January",
    "Feb": "February",
    "Mar": "March",
    "Apr": "April",
    "May": "May",
    "Jun": "June",
    "Jul": "July",
    "Aug": "August",
    "Sep": "September",
    "Oct": "October",
    "Nov": "November",
    "Dec": "December"
};

module.exports = {
    PURCHASE_ORDER_TYPE,
    YES,
    NO,
    SHOPIFY_AMAZON_FILTERS,
    SHOPIFY,
    AMAZON,
    endDateOfProfitAndLossReport,
    enumCommonBooleanStatuses,
    enumShopifyAmazon,
    BOOLEAN_FILTERS,
    DEFAULT_COUNT_BOXES,
    BETA_ENV,
    VENDOR_SHIP_TODAY,
    VENDOR_SHIP_SOON,
    VENDOR_SHIP_OLD,
    PO_EMAIL,
    PO_PAYMENT_CONFIRMATION,
    monthNames
}